import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Index = () => import('@/pages/index');
const Agreement = () => import('@/pages/agreement');// 用户协议
const AgreementTxsy = () => import('@/pages/agreementTxsy');// 用户协议
const Protocol = () => import('@/pages/protocol');// 隐私政策
const ProtocolTxsy = () => import('@/pages/protocolTxsy');// 隐私政策

const LogoffProtocol = () => import('@/pages/logoffProtocol');// 注销协议

const payPage = () => import('@/pages/pay');// 支付页
const payBack = () => import('@/pages/payBack');// 支付回调页
const landingPage = () => import('@/pages/share/landingPage.vue');// 支付回调页
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    }, {
      path: '/index',
      name: 'Index',
      component: Index
    }, {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement
    }, {
      path: '/agreement_txsy',
      name: 'AgreementTxsy',
      component: AgreementTxsy
    }, {
      path: '/protocol',
      name: 'Protocol',
      component: Protocol
    },{
      path: '/protocol_txsy',
      name: 'ProtocolTxsy',
      component: ProtocolTxsy
    }, {
      path: '/logoffProtocol',
      name: 'LogoffProtocol',
      component: LogoffProtocol
    }, {
      path: '/pay',
      name: 'pay',
      component: payPage
    }, {
      path: '/payBack',
      name: 'payBack',
      component: payBack
    }, {
      path: '/landing_page',
      name: 'payBack',
      component: landingPage
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
